// JS that is used on Cart Page & Cart Drawer

(function() {
  const init = function() {
    if (!window.customElements.get("cart-note")) {
      // js/custom-element/section/cart/cart-note.js
      var CartNote = class extends HTMLTextAreaElement {
        connectedCallback() {
          this.addEventListener("change", this._onNoteChanged.bind(this));
        }
        get ownedToggle() {
          return this.hasAttribute("aria-owns") ? document.getElementById(this.getAttribute("aria-owns")) : null;
        }
        async _onNoteChanged() {
          if (this.ownedToggle) {
            this.ownedToggle.innerHTML = this.value === "" ? window.themeVariables.strings.cartAddOrderNote : window.themeVariables.strings.cartEditOrderNote;
          }
          const response = await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
            body: JSON.stringify({ note: this.value }),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            }
          });
          const cartContent = await response.json();
          document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent
            }
          }));
        }
      };
      window.customElements.define("cart-note", CartNote, { extends: "textarea" });
    }
    if (!window.customElements.get("free-extra-bar")) {
      // js/custom-element/section/cart/free-extra-bar.js
      var FreeExtraBar = class extends HTMLElement {
        connectedCallback() {
          document.documentElement.addEventListener("cart:updated", this._onCartUpdated.bind(this));
        }
        get threshold() {
          return parseFloat(this.getAttribute("threshold"));
        }
        _onCartUpdated(event) {
          this.style.setProperty("--progress", Math.min(parseFloat(event.detail["cart"]["total_price"]) / this.threshold, 1));
        }
      };
      window.customElements.define("free-extra-bar", FreeExtraBar);
    }
    if (!window.customElements.get("line-item-quantity")) {
      // js/custom-element/section/cart/item-quantity.js
      var LineItemQuantity = class extends CustomHTMLElement {
        connectedCallback() {
          this.delegate.on("click", "a", this._onQuantityLinkClicked.bind(this));
          this.delegate.on("change", "input", this._onQuantityChanged.bind(this));
        }
        _onQuantityLinkClicked(event, target) {
          event.preventDefault();
          this._updateFromLink(target.href);
        }
        _onQuantityChanged(event, target) {
          this._updateFromLink(`${window.themeVariables.routes.cartChangeUrl}?quantity=${target.value}&line=${target.getAttribute("data-line")}`);
        }
        async _updateFromLink(link) {
          const changeUrl = new URL(link, `https://${window.themeVariables.routes.host}`), searchParams = changeUrl.searchParams, line = searchParams.get("line"), id = searchParams.get("id"), quantity = parseInt(searchParams.get("quantity"));

          if (window.themeVariables.settings.pageType === "cart") {
            let lineItem = window.cartData?.items.find(item => item.key === id || item.position === line - 1);
            if (lineItem) {
              const currentQuantity = parseInt(lineItem.quantity);
              if (quantity > currentQuantity) {
                const eventData = {
                  event: "dl_add_to_cart",
                  ecommerce: {
                    currencyCode: window.cartData.currencyCode,
                    add: {
                      products: [{
                        id: lineItem.id,
                        name: lineItem.name,
                        brand: lineItem.brand,
                        category: lineItem.category,
                        variant: lineItem.variant,
                        price: lineItem.price,
                        quantity: quantity - currentQuantity,
                        list: lineItem.category,
                        product_id: lineItem.productId,
                        variant_id: lineItem.variantId,
                        compare_at_price: lineItem.compareAtPrice,
                        image: lineItem.image
                      }]
                    }
                  }
                };
                window.pushEventWithConsent(eventData);
              } else if (quantity < currentQuantity) {
                const eventData = {
                  event: "dl_remove_from_cart",
                  ecommerce: {
                    currencyCode: window.cartData.currencyCode,
                    remove: {
                      products: [{
                        id: lineItem.id,
                        name: lineItem.name,
                        brand: lineItem.brand,
                        category: lineItem.category,
                        variant: lineItem.variant,
                        price: lineItem.price,
                        quantity: currentQuantity - quantity,
                        list: lineItem.category,
                        product_id: lineItem.productId,
                        variant_id: lineItem.variantId,
                        image: lineItem.image
                      }]
                    }
                  }
                };
                window.pushEventWithConsent(eventData);
              }
            }

            window.location.href = link;
            return;
          }

          this.dispatchEvent(new CustomEvent("line-item-quantity:change:start", { bubbles: true, detail: { newLineQuantity: quantity } }));
          const response = await fetch(`${window.themeVariables.routes.cartChangeUrl}.js`, {
            body: JSON.stringify({ line, id, quantity, sections: ["mini-cart"] }),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            }
          });
          const cartContent = await response.json();

          if(cartContent.items_added.length > 0) {
            let products = [];
            cartContent.items_added.forEach((item) => {
              products.push({
                id: item.id,
                name: item.title,
                category: item.product_type,
                variant: item.title,
                price: item.price,
                quantity: item.quantity,
                product_id: item.product_id,
                variant_id: item.variant_id,
                image: item.image
              });
            });

            const eventData = {
              event: "dl_add_to_cart",
              ecommerce: {
                currencyCode: 'EUR',
                add: {
                  products: products
                }
              }
            };
            window.pushEventWithConsent(eventData);
          }
          if(cartContent.items_removed.length > 0) {
            let products = [];
            cartContent.items_removed.forEach((item) => {
              products.push({
                id: item.id,
                name: item.title,
                category: item.product_type,
                variant: item.title,
                price: item.price,
                quantity: item.quantity,
                product_id: item.product_id,
                variant_id: item.variant_id,
                image: item.image
              });
            });

            const eventData = {
              event: "dl_remove_from_cart",
              ecommerce: {
                currencyCode: 'EUR',
                remove: {
                  products: products
                }
              }
            };
            window.pushEventWithConsent(eventData);
          }

          this.dispatchEvent(new CustomEvent("line-item-quantity:change:end", { bubbles: true, detail: { cart: cartContent, newLineQuantity: quantity } }));
          document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent
            }
          }));
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              replacementDelay: quantity === 0 ? 600 : 750
            }
          }));
        }
      };
      window.customElements.define("line-item-quantity", LineItemQuantity);
    }
    if (!window.customElements.get("line-item")) {
      // js/custom-element/section/cart/line-item.js
      var LineItem = class extends HTMLElement {
        connectedCallback() {
          this.lineItemLoader = this.querySelector(".line-item__loader");
          this.addEventListener("line-item-quantity:change:start", this._onQuantityStart.bind(this));
          this.addEventListener("line-item-quantity:change:end", this._onQuantityEnd.bind(this));
        }
        _onQuantityStart() {
          if (!this.lineItemLoader) {
            return;
          }
          this.lineItemLoader.hidden = false;
          this.lineItemLoader.firstElementChild.hidden = false;
          this.lineItemLoader.lastElementChild.hidden = true;
        }
        async _onQuantityEnd(event) {
          if (event.detail.cart["item_count"] === 0) {
            return;
          }
          if (this.lineItemLoader) {
            await this.lineItemLoader.firstElementChild.animate({ opacity: [1, 0], transform: ["translateY(0)", "translateY(-10px)"] }, 75).finished;
            this.lineItemLoader.firstElementChild.hidden = true;
            if (event.detail.newLineQuantity === 0) {
              await this.animate({ opacity: [1, 0], height: [`${this.clientHeight}px`, 0] }, { duration: 300, easing: "ease" }).finished;
              this.remove();
            } else {
              this.lineItemLoader.lastElementChild.hidden = false;
              await this.lineItemLoader.lastElementChild.animate({ opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] }, { duration: 75, endDelay: 300 }).finished;
              this.lineItemLoader.hidden = true;
            }
          }
        }
      };
      window.customElements.define("line-item", LineItem);
    }
  }
  if (window.criticalLoaded) { init() }
  else { document.addEventListener("critical-js:loaded", init); }
})();